import IAmount from "@/module/main/dto/IAmount";
import IInstallmentSettings from "@/module/main/dto/IInstallmentSettings";

export default class InstallmentSettings implements IInstallmentSettings
{
    constructor(
        public preferredInstallment: IAmount | undefined,
        public productCode: string | undefined,
        public productSetCode: string | undefined)
    {
    }
}
